/* eslint-disable
    import/default,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import { Map } from 'immutable'

import InboxConstants from 'constants/InboxConstants'
import ConversationConstants from 'constants/ConversationConstants'
import InboxQueries from 'queries/InboxQueries'
import * as Helpers from 'utils/Helpers'

const InboxStore = Marty.createStore({
  id: 'InboxStore',

  getInitialState() {
    return {
      inboxesById: {},
      inboxCreationState: undefined,
      lastCreatedInboxId: undefined,
      inboxExistenceByEmail: {},
      whiteListLabelsByDomain: {}
    }
  },

  handlers: {
    getOrFetchInboxList: InboxConstants.INBOX_LIST_FETCH,
    fetchInboxListDone: InboxConstants.INBOX_LIST_FETCH_DONE,

    fetchInboxDone: InboxConstants.INBOX_FETCH_DONE,

    archiveInbox: InboxConstants.INBOX_ARCHIVE,
    archiveInboxDone: InboxConstants.INBOX_ARCHIVE_DONE,

    updateInbox: InboxConstants.INBOX_UPDATE,
    updateInboxDone: InboxConstants.INBOX_UPDATE_DONE,

    createInbox: InboxConstants.INBOX_CREATE,
    createInboxDone: InboxConstants.INBOX_CREATE_DONE,

    checkInboxExistsForEmail: InboxConstants.CHECK_INBOX_EXISTENCE_BY_EMAIL,
    checkInboxExistsForEmailDone: InboxConstants.CHECK_INBOX_EXISTENCE_BY_EMAIL_DONE,

    createWhiteListLabels: InboxConstants.WHITE_LIST_LABELS_CREATE,
    createWhiteListLabelsDone: InboxConstants.WHITE_LIST_LABELS_CREATE_DONE,

    validateWhiteListLabels: InboxConstants.WHITE_LIST_LABELS_VALIDATE,
    validateWhiteListLabelsDone: InboxConstants.WHITE_LIST_LABELS_VALIDATE_DONE,

    fetchWhiteListLabelsDone: InboxConstants.WHITE_LIST_LABELS_FETCH_DONE
  },

  getOrFetchInboxList() {
    return this.fetch({
      id: 'fetchInboxList',
      locally() {
        if (this.hasAlreadyFetched('fetchInboxList')) {
          return this.state.inboxesById
        }
      },
      remotely() {
        return this.app.queries.InboxQueries.fetchInboxes()
      }
    })
  },

  getInboxList() {
    return _.values(this.state.inboxesById)
  },

  fetchInboxListDone(inboxes) {
    const inboxesById = _.keyBy(inboxes, 'id')
    return this.setState({ inboxesById: _.merge(inboxesById, this.state.inboxesById) })
  },

  getOrFetchInbox(inboxId) {
    return this.fetch({
      id: `fetchInbox${ inboxId }`,
      locally() {
        if (this.state.inboxesById) {
          return this.state.inboxesById[inboxId]
        }
      },
      remotely() {
        return this.app.queries.InboxQueries.fetchInbox(inboxId)
      }
    })
  },

  fetchInboxDone(inboxId, inbox) {
    const inboxesById = this._cloneInbox()
    inboxesById[inboxId] = inbox
    return this.setState({ inboxesById })
  },

  _cloneInbox() {
    return _.cloneDeep(this.state.inboxesById) || {}
  },

  updateInbox(inboxId, params) {
    return this.app.queries.InboxQueries.updateInbox(inboxId, params)
  },

  updateInboxDone(inboxId, inbox) {
    const inboxesById = this._cloneInbox()
    inboxesById[inboxId] = inbox
    return this.setState({ inboxesById })
  },

  createInbox(params) {
    return this.app.queries.InboxQueries.createInbox(params)
  },

  createInboxDone(inbox) {
    this.setState({
      lastCreatedInboxId: inbox.id
    })

    const inboxesById = this._cloneInbox()
    inboxesById[inbox.id] = inbox
    return this.setState({ inboxesById })
  },

  resetLastCreatedInbox() {
    return this.setState({
      lastCreatedInboxId: undefined
    })
  },

  getLastCreatedInbox() {
    return this.state.inboxesById[this.state.lastCreatedInboxId]
  },

  getInboxExistenceByEmail() {
    return this.state.inboxExistenceByEmail
  },

  checkInboxExistsForEmail(email) {
    if ((this.state.inboxExistenceByEmail[email] == null)) {
      return this.app.queries.InboxQueries.checkInboxExistsForEmail(email)
    }
  },

  checkInboxExistsForEmailDone(email, exists) {
    const inboxExistenceByEmail = _.cloneDeep(this.state.inboxExistenceByEmail)
    inboxExistenceByEmail[email] = exists
    return this.setState({ inboxExistenceByEmail })
  },

  createWhiteListLabels(domain) {
    const whiteListLabels = _.cloneDeep(this.state.whiteListLabelsByDomain)
    if (whiteListLabels[domain] != null) {
      whiteListLabels[domain].isConfiguring = true
    }
    this.setState({ whiteListLabelsByDomain: whiteListLabels })

    return this.app.queries.InboxQueries.createWhiteListLabels(domain)
  },

  createWhiteListLabelsDone(domain, payload) {
    return this.storeWhiteListLabelsByDomain(domain, payload)
  },

  fetchWhiteListLabelsDone(domain, payload) {
    return this.storeWhiteListLabelsByDomain(domain, payload)
  },

  storeWhiteListLabelsByDomain(domain, payload) {
    const whiteListLabels = _.cloneDeep(this.state.whiteListLabelsByDomain)

    const config = payload != null ? payload.dns : undefined

    if (!!!config) {
      whiteListLabels[domain] = {}
      this.setState({ whiteListLabelsByDomain: whiteListLabels })
      return
    }

    whiteListLabels[domain] = {
      isConfiguring: false,
      dns: [
        {
          data: config.mail_cname.data,
          host: config.mail_cname.host,
          state: config.mail_cname.valid ? InboxConstants.WHITE_LIST_LABELS_VALIDATE_DONE : InboxConstants.WHITE_LIST_LABELS_VALIDATE_FAILED
        },
        {
          data: config.dkim1.data,
          host: config.dkim1.host,
          state: config.dkim1.valid ? InboxConstants.WHITE_LIST_LABELS_VALIDATE_DONE : InboxConstants.WHITE_LIST_LABELS_VALIDATE_FAILED
        },
        {
          data: config.dkim2.data,
          host: config.dkim2.host,
          state: config.dkim2.valid ? InboxConstants.WHITE_LIST_LABELS_VALIDATE_DONE : InboxConstants.WHITE_LIST_LABELS_VALIDATE_FAILED
        }
      ]
    }

    return this.setState({ whiteListLabelsByDomain: whiteListLabels })
  },

  getDomainByInboxId(inboxId) {
    const inbox = this.state.inboxesById[inboxId]
    return Helpers.getDomainFromEmail(inbox != null ? inbox.address : undefined)
  },

  getOrFetchWhiteListLabels(inboxId) {
    let domain
    return this.fetch({
      id: 'fetchWhiteLabels',
      dependsOn: this.getOrFetchInbox(inboxId),
      locally: () => {
        domain = this.getDomainByInboxId(inboxId)
        return this.state.whiteListLabelsByDomain[domain]
      },
      remotely() {
        domain = this.getDomainByInboxId(inboxId)
        return this.app.queries.InboxQueries.fetchWhiteListLabelsByDomain(domain)
      }
    })
  },

  validateWhiteListLabels(domain) {
    const whiteListLabels = _.cloneDeep(this.state.whiteListLabelsByDomain)

    whiteListLabels[domain].dns = _.map(whiteListLabels[domain].dns, function(item) {
      item.state = InboxConstants.WHITE_LIST_LABELS_VALIDATE_STARTING
      return item
    })

    this.setState({ whiteListLabelsByDomain: whiteListLabels })

    return this.app.queries.InboxQueries.validateWhiteListLabels(domain)
  },

  validateWhiteListLabelsDone(domain, payload) {
    return this.storeWhiteListLabelsByDomain(domain, payload)
  },

  archiveInbox(inboxId) {
    return this.app.queries.InboxQueries.archiveInbox(inboxId)
  },

  archiveInboxDone(inboxId) {
    const inboxes = this._cloneInbox()
    delete inboxes[inboxId]
    this.setState({ inboxesById: inboxes })
    return this.hasChanged()
  }

})

export default InboxStore



// WEBPACK FOOTER //
// ./src/scripts/stores/InboxStore.js